import * as React from "react";
import { useStore } from "@ludens-reklame/rubics-v3-react/store/hooks";
import { Constrainer } from "../../internal-components/Layout.js";
import { ButtonAction, ButtonActionProps } from "../../internal-components/Button.js";
import { chevron } from "../../icons/index.js";
import { JobPageProps } from "../JobListings/JobListings.js";
import {
  InfoKortSpacer,
  InfoKortCard,
  InfoKortMeta,
  InfoKortMetaItem,
  InfoKortMetaLabel,
  InfoKortMetaValue,
  InfoKortApply,
} from "./styles.js";

export interface InfoKortItem {
  label?: string;
  value?: string;
}

export interface InfoKortProps {
  applyButton?: ButtonActionProps;
  variant?: "stillinginfo" | "egendefinert";
  items?: InfoKortItem[];
}

export const InfoKort: React.FC<InfoKortProps> = ({
  applyButton,
  variant = "stillinginfo",
  items = [],
}) => {
  const store = useStore();
  const pageProps = store.context.page?.props as JobPageProps | undefined;

  if (variant === "stillinginfo") {
    const location = pageProps?.location;
    const department = pageProps?.department?.name;
    const deadline = pageProps?.deadline;

    if (!location && !department && !deadline) return null;

    return (
      <InfoKortSpacer>
        <Constrainer>
          <InfoKortCard>
            <InfoKortMeta>
              {location && (
                <InfoKortMetaItem>
                  {chevron}
                  <div>
                    <InfoKortMetaLabel>Sted</InfoKortMetaLabel>

                    <InfoKortMetaValue>{location}</InfoKortMetaValue>
                  </div>
                </InfoKortMetaItem>
              )}
              {department && (
                <InfoKortMetaItem>
                  {chevron}
                  <div>
                    <InfoKortMetaLabel>Selskap</InfoKortMetaLabel>
                    <InfoKortMetaValue>{department}</InfoKortMetaValue>
                  </div>
                </InfoKortMetaItem>
              )}
              {deadline && (
                <InfoKortMetaItem>
                  {chevron}
                  <div>
                    <InfoKortMetaLabel>Frist</InfoKortMetaLabel>
                    <InfoKortMetaValue>{deadline}</InfoKortMetaValue>
                  </div>
                </InfoKortMetaItem>
              )}
            </InfoKortMeta>
            {applyButton?.link && (
              <InfoKortApply>
                <ButtonAction {...applyButton} />
              </InfoKortApply>
            )}
          </InfoKortCard>
        </Constrainer>
      </InfoKortSpacer>
    );
  }

  const validItems = items.filter((i) => i.label && i.value);
  if (validItems.length === 0 && !applyButton?.link) return null;

  return (
    <InfoKortSpacer>
      <Constrainer>
        <InfoKortCard>
          <InfoKortMeta>
            {validItems.map((item, i) => (
              <InfoKortMetaItem key={i}>
                {chevron}
                <div>
                  <InfoKortMetaLabel>{item.label}</InfoKortMetaLabel>
                  <InfoKortMetaValue>{item.value}</InfoKortMetaValue>
                </div>
              </InfoKortMetaItem>
            ))}
          </InfoKortMeta>
          {applyButton?.link && (
            <InfoKortApply>
              <ButtonAction {...applyButton} />
            </InfoKortApply>
          )}
        </InfoKortCard>
      </Constrainer>
    </InfoKortSpacer>
  );
};
